import React, { Component } from "react"

import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"

class ButtonSigninMaterial extends Component {
	render() {
		const {
			t,
			classes,
			finishlocal,
			handleConfirmationSubmit,
			validateForm
		} = this.props
		return (
			<div className={classes.root}>
				<div className={classes.wrapper}>
					<Button
						aria-label="handleConfirmationSubmit"
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						disabled={finishlocal || !validateForm()}
						className={classes.submit}
						onClick={event => handleConfirmationSubmit(event, t)}
					>
						{t("NavBarDesktop.NavBarDesktopSignIn")}
					</Button>
					{finishlocal && (
						<CircularProgress
							size={24}
							className={classes.buttonProgressSignin}
						/>
					)}
				</div>
			</div>
		)
	}
}
export default ButtonSigninMaterial
